import self from "../img/self.png"
import mock1 from "../img/mock1.png"
import mock2 from "../img/mock2.png"

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */


/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
    firstName: "Damith",
    lastName: "Fernando",
    initials: "Damith Fernando", // the example uses first and last, but feel free to use three or more if you like.
    position: "a Frontend Developer",
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    baseColor: colors[0],
    miniBio: [ // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
        {
            emoji: '☕',
            text: 'Fueled by coffee'
        },
        {
            emoji: '🌎',
            text: 'Based in the Japan'
        },
        {
            emoji: "💼",
            text: "Systems Engineer at Lanex"
        },
        {
            emoji: "📧",
            text: "damith.asanka90@gmail.com"
        }
    ],
    socials: [
        {
            link: "https://www.facebook.com/damithfdo95/",
            icon: 'fa fa-facebook',
            label: 'facebook'
        },
        {
            link: "https://instagram.com/damithfdo95",
            icon: 'fa fa-instagram',
            label: 'instagram'
        },
        {
            link: "https://github.com/damithfdo95",
            icon: "fa fa-github",
            label: 'github'
        },
        {
            link: "https://www.linkedin.com/in/damith-fdo95/",
            icon: "fa fa-linkedin",
            label: 'linkedin'
        }
// Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
// Just change the links so that they lead to your social profiles.

    ],
    bio: "Hello! I'm Damith Fernando. I'm a Systems Engineer in Lanex. I studied at Tohoku Computer College Japan, I enjoy long walks on the beach, and I believe artificial intelligence will inevitably rule us all one day. I'm confident that I have skills and experience necessary. I'm also motivated to get the job done, And I have a lot of Enthusiasm..!",
    skills:
        {
            proficientWith: ['html5', 'css3','javascript', 'react', 'git', 'github', 'gitLab', 'bootstrap',  'figma'],
            exposedTo: ['Node.js', 'Express.js']
        }
    ,
    hobbies: [
        {
            label: 'travelling',
            emoji: '🌎'
        },
        {
            label: 'cricket',
            emoji: '🏏'
        },
        {
            label: 'basketball',
            emoji: '🏀'
        },
        {
            label: 'movies',
            emoji: '🍿'
        },
        {
            label: 'cooking',
            emoji: '🍳'
        }
// Same as above, change the emojis to match / relate to your hobbies or interests.
// You can also remove the emojis if you'd like, I just think they look cute :P
    ],
    portfolio: [ // This is where your portfolio projects will be detailed
        {
            title: "Gaijin Blog",
            live: "https://www.gaijinblog.com/", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
            source: "https://github.com/damithfdo95", // this should be a link to the **repository** of the project, where the code is hosted.
            image: mock1
        },
        {
            title: "Spicy Divine",
            live: "http://www.spicydivine.shop/",
            source: "https://github.com/damithfdo95",
            image: mock2
        },
        // {
        //     title: "Project 3",
        //     live: "https://damith.netlify.app",
        //     source: "https://github.com/damithfdo95",
        //     image: mock3
        // },
        // {
        //     title: "Project 4",
        //     live: "https://damith.netlify.app",
        //     source: "https://github.com/damithfdo95",
        //     image: mock4
        // },
        // {
        //     title: "Project 5",
        //     live: "https://damith.netlify.app",
        //     source: "https://github.com/damithfdo95",
        //     image: mock5
        // }
    ]
}
